import React from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { WeaLocaleProvider, WeaRichText } from "ecCom";
import uniqueId from "lodash/uniqueId";
import middleware from "../../../middleware";

const Plugins = WeaRichText.plugins;
const getLabel = WeaLocaleProvider.getLabel;

class BarItem extends React.PureComponent {
  onClick = () => this.props.onClick(this.props.item);
  showListCb = showList => this.props.showListCb(this.props.item, showList);
  render() {
    const { prefixCls, item, onToolsChange, onCancel } = this.props;
    const Tool = Plugins[item.name];
    return (
      <span
        className={`${prefixCls}-bottomBar-item`}
        style={{ position: "relative", ...item.style }}
        onClick={this.onClick}
      >
        {
          <Tool
            onToolsChange={onToolsChange}
            {...item}
            onCancel={onCancel}
            showListCb={this.showListCb}
          />
        }
      </span>
    );
  }
}

@observer
class Autograph extends React.PureComponent {
  static defaultProps = {
    prefixCls: "wea-autograph",
    className: "",
    style: {}
  };
  constructor(props) {
    super(props);
    this.index = uniqueId();
    this.state = {
      editType: 0, //EditType:默认签章类型，0:签名 1:文字  默认值:0
      isIE: true,
      showIframe: false // 用于遮挡object对象
    };
  }

  componentDidMount() {
    const {
      weaworkflow_autograph_store: {
        getAutographInfo,
        setMobxState,
        saveAutograph
      },
      params,
      recordId,
      onStatusChange,
      indexOfAutograph
    } = this.props;
    window.saveAutograph = saveAutograph;
    if (indexOfAutograph) {
      if (!window.saveAutographMul) {
        // 多个签章的save方法，兼容其他模块
        window.saveAutographMul = {};
      }
      window.saveAutographMul[indexOfAutograph] = saveAutograph;
    }
    const ua = navigator.userAgent.toLowerCase();
    const isMsie = /msie ([\d.]+)/.test(ua);
    const isEdge = /edge/.test(ua);
    const isie = /rv:([\d.]+)\) like gecko/.test(ua);
    const isIE = isMsie || isie || isEdge;
    this.setState({ isIE });
    setMobxState({ recordId });
    isIE
      ? getAutographInfo(params).then(() => {
          this.reLoadConsult();
        })
      : typeof onStatusChange === "function" && onStatusChange("ready");
  }

  reLoadConsult = () => {
    const {
      weaworkflow_autograph_store: {
        initInfo: {
          formSignatureWidth,
          formSignatureHeight,
          revisionClassId,
          revisionClientUrl
        }
      }
    } = this.props;
    if (jQuery(`#Consult${this.index}`))
      jQuery(`#Consult${this.index}`).remove();
    jQuery(`#formSignatureTd-${this.index}`).append(
      `<object width="${formSignatureWidth}" height="${formSignatureHeight}" id="Consult${this.index}" classid="${revisionClassId}" codebase="${revisionClientUrl}"></object>`
    );
    if (revisionClientUrl) this.initAutograph();
  };

  initAutograph() {
    const { weaworkflow_autograph_store, onStatusChange } = this.props;
    const { initInfo, setMobxState, recordId } = weaworkflow_autograph_store;
    // window.document.Consult可适配于流程表单字段中
    window.document[`Consult${this.index}`].WebUrl =
      "/workflow/request/RevisionServer.jsp"; //WebUrl:系统服务器路径，与服务器交互操作，如打开签章信息
    // Consult.WebUrl = initInfo.WebUrl; //WebUrl:系统服务器路径，与服务器交互操作，如打开签章信息
    window.document[`Consult${this.index}`].RecordID =
      recordId || initInfo.RecordID || "-1"; //RecordID:本文档记录编号
    window.document[`Consult${this.index}`].FieldName = "Consult"; //FieldName:签章窗体可以根据实际情况再增加，只需要修改控件属性 FieldName 的值就可以
    window.document[`Consult${this.index}`].UserName = initInfo.UserName; //UserName:签名用户名称
    window.document[`Consult${this.index}`].WebSetMsgByName(
      "USERID",
      initInfo.UserId
    ); //USERID:签名用户id
    window.document[`Consult${this.index}`].Enabled = initInfo.Consult_Enabled; //Enabled:是否允许修改，0:不允许 1:允许  默认值:1
    window.document[`Consult${this.index}`].PenColor = initInfo.PenColor; //PenColor:笔的颜色，采用网页色彩值  默认值:#000000
    window.document[`Consult${this.index}`].BorderStyle = "0"; //BorderStyle:边框，0:无边框 1:有边框  默认值:1
    window.document[`Consult${this.index}`].EditType = initInfo.EditType; //EditType:默认签章类型，0:签名 1:文字  默认值:0
    window.document[`Consult${this.index}`].ShowPage = initInfo.ShowPage; //ShowPage:设置默认显示页面，0:电子印章,1:网页签批,2:文字批注  默认值:0
    window.document[`Consult${this.index}`].InputText = ""; //InputText:设置署名信息，  为空字符串则默认信息[用户名+时间]内容
    window.document[`Consult${this.index}`].PenWidth = initInfo.PenWidth; //PenWidth:笔的宽度，值:1 2 3 4 5   默认值:2
    window.document[`Consult${this.index}`].FontSize = initInfo.FontSize; //FontSize:文字大小，默认值:11
    window.document[`Consult${this.index}`].ShowMenu = "0";
    window.document[`Consult${this.index}`].SignatureType =
      initInfo.SignatureType; //SignatureType:签章来源类型，0表示从服务器数据库中读取签章，1表示从硬件密钥盘中读取签章，2表示从本地读取签章，并与ImageName(本地签章路径)属性相结合使用  默认值:0}
    window.document[`Consult${this.index}`].InputList = initInfo.InputList; //InputList:设置文字批注信息列表
    window.document[`Consult${this.index}`].ShowUserListMenu = "true"; //签批用户列表是否显示，"true"为显示
    window.document[`Consult${this.index}`].FontName = initInfo.FontName; // 设置字体名称
    window.document[`Consult${this.index}`].CASignType = initInfo.CASignType; //默认为不启用数字签名
    window.document[`Consult${this.index}`].SetFieldByName(
      "DocEmptyJuggle",
      initInfo.DocEmptyJuggle
    );
    window.document[`Consult${this.index}`].LoadSignature(); //调用签章数据信息
    window.document[`Consult${this.index}`].ImgWidth =
      initInfo.formSignatureWidth;
    window.document[`Consult${this.index}`].ImgHeight =
      initInfo.formSignatureHeight;
    setMobxState({
      isAutoResizeSignImage: initInfo.isAutoResizeSignImage,
      index: this.index,
      indexOfAutograph: this.props.indexOfAutograph
    });
    this.setState({ editType: initInfo.EditType });
    typeof onStatusChange === "function" && onStatusChange("ready");
  }

  getHash = prefixCls =>
    prefixCls +
    Math.random()
      .toString(36)
      .substr(2, 6);

  openSignature = () =>
    this.state.isIE && window.document[`Consult${this.index}`].OpenSignature();

  changeEditType = () =>
    this.state.isIE &&
    this.setState(
      {
        editType: window.document[`Consult${this.index}`].EditType === 0 ? 1 : 0
      },
      () => {
        window.document[`Consult${this.index}`].EditType = this.state.editType;
      }
    );

  showSignature = () =>
    this.state.isIE && window.document[`Consult${this.index}`].ShowSignature();

  clear = () =>
    this.state.isIE && window.document[`Consult${this.index}`].Clear();

  clearAll = () =>
    this.state.isIE && window.document[`Consult${this.index}`].ClearAll();

  chgReadSignatureType = () => {
    if (this.state.isIE) {
      const res =
        window.document[`Consult${this.index}`].SignatureType === 1 ? 0 : 1;
      if (this.state.isIE) {
        window.document[`Consult${this.index}`].SignatureType = res;
        if (res === 0) alert(getLabel("529128", "签章从数据库中读取"));
        else alert(getLabel("529129", "签章从智能钥匙盘中读取"));
      }
    }
  };

  showZoomInHandWrite = () =>
    this.state.isIE &&
    window.document[`Consult${this.index}`].ShowZoomInHandWrite();

  getBtns = () => {
    const { editType } = this.state;
    const { prefixCls } = this.props;
    return [
      {
        id: 1,
        icon: (
          <span
            className={`icon-coms02-form-Sign ${prefixCls}-tooltab-img`}
            onClick={this.openSignature}
          >
            <span className="path1" />
            <span className="path2" />
          </span>
        ),
        onClick: this.openSignature,
        showname: getLabel("21431", "打开签章")
      },
      {
        id: 2,
        icon: (
          <span
            className={`${
              editType === 0
                ? "icon-coms02-form-to-write"
                : "icon-coms02-from-Text"
            } ${prefixCls}-tooltab-img`}
            onClick={this.changeEditType}
          >
            <span className="path1" />
            <span className="path2" />
          </span>
        ),
        onClick: this.changeEditType,
        showname:
          editType === 0
            ? getLabel("25349", "手写签批")
            : getLabel("21441", "文字签批")
      },
      {
        id: 3,
        icon: (
          <span
            className={`icon-coms02-from-SignList ${prefixCls}-tooltab-img`}
            onClick={this.showSignature}
          >
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
            <span className="path4" />
            <span className="path5" />
            <span className="path6" />
          </span>
        ),
        onClick: this.showSignature,
        showname: getLabel("21432", "签章列表")
      },
      {
        id: 4,
        icon: (
          <span
            className={`icon-coms02-from-cancel ${prefixCls}-tooltab-img`}
            onClick={this.clear}
          >
            <span className="path1" />
            <span className="path2" />
          </span>
        ),
        onClick: this.clear,
        showname: getLabel("21433", "取消修改")
      },
      {
        id: 5,
        icon: (
          <span
            className={`icon-coms02-from-Empty ${prefixCls}-tooltab-img`}
            onClick={this.clearAll}
          >
            <span className="path1" />
            <span className="path2" />
          </span>
        ),
        onClick: this.clearAll,
        showname: getLabel("21434", "清空全部")
      },
      {
        id: 6,
        icon: (
          <span
            className={`icon-coms02-from-Switching ${prefixCls}-tooltab-img`}
            onClick={this.chgReadSignatureType}
          >
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
            <span className="path4" />
            <span className="path5" />
            <span className="path6" />
          </span>
        ),
        onClick: this.chgReadSignatureType,
        showname: getLabel("21435", "切换签章来源")
      },
      {
        id: 7,
        icon: (
          <span
            className={`icon-coms02-from-Full-screen ${prefixCls}-tooltab-img ${prefixCls}-tooltab-img-right`}
            onClick={this.showZoomInHandWrite}
          >
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
            <span className="path4" />
            <span className="path5" />
          </span>
        ),
        onClick: this.showZoomInHandWrite,
        showname: ""
      }
    ];
  };
  getToolTabs = () => {
    const {
      prefixCls,
      weaworkflow_autograph_store: {
        initInfo: { btnConfig }
      }
    } = this.props;
    const btnConfigs = toJS(btnConfig);
    const btnsCom = this.getBtns();
    return (
      <tr className={`${prefixCls}-tooltab-tr`}>
        {btnConfigs &&
          btnsCom &&
          btnsCom.map(btn => {
            const showbtn = btnConfigs.filter(v => v.id === btn.id)[0].open;
            return showbtn ? (
              <td className={`${prefixCls}-tooltab-td`}>
                {btn.icon}
                <a
                  className={`${prefixCls}-tooltab-label`}
                  onClick={btn.onClick}
                >
                  {btn.showname}
                </a>
              </td>
            ) : null;
          })}
      </tr>
    );
  };

  onToolsChange = (type, ids, list, lev2Type) => {
    const { onToolsChange } = this.props;
    typeof onToolsChange === "function" &&
      onToolsChange(type, ids, list, lev2Type);
    this.showIframeFunc(false);
  };

  showIframeFunc = (showIframe = true) => {
    this.setState({ showIframe });
  };

  onItemClick = item => {
    if (item.name !== "Upload") this.showIframeFunc(true);
  };

  onItemCancel = () => this.showIframeFunc(false);

  showListCb = (item, showList) => {
    if (item.name !== "Upload") this.showIframeFunc(showList);
  };

  getBootomBarItems = () => {
    const { bottomBarConfig = [], prefixCls } = this.props;
    const items = [];
    bottomBarConfig.forEach(item => {
      if (item.name === "Component") {
        items.push(
          <span
            className={`${prefixCls}-bottomBar-item`}
            style={{ position: "relative", ...item.style }}
          >
            {item.show}
          </span>
        );
      } else {
        items.push(
          <BarItem
            prefixCls={prefixCls}
            item={item}
            onClick={this.onItemClick}
            onCancel={this.onItemCancel}
            onToolsChange={this.onToolsChange}
            showListCb={this.showListCb}
          />
        );
      }
    });
    return items;
  };

  render() {
    const {
      weaworkflow_autograph_store,
      prefixCls,
      className,
      style
    } = this.props;
    const { isIE, showIframe } = this.state;
    const {
      visible,
      initInfo: { formSignatureHeight = 200, formSignatureWidth }
    } = weaworkflow_autograph_store;
    if (!visible) return null;
    return (
      <div
        id="consultdiv"
        className={`wea-rich-text ${prefixCls} ${className}`}
        style={style}
      >
        <table
          className={`${prefixCls}-tooltab`}
          cellspacing="0"
          cellpadding="0"
          align="center"
        >
          <tbody>{this.getToolTabs()}</tbody>
        </table>
        {isIE ? (
          <div
            className={`${prefixCls}-consulttab`}
            style={{ height: formSignatureHeight + 5 }}
          >
            <table
              id="consulttab"
              width={formSignatureWidth + "px"}
              height={formSignatureHeight + "px"}
              cellspacing="0"
              cellpadding="0"
              align="left"
            >
              <tbody>
                <tr>
                  <td
                    id={`formSignatureTd-${this.index}`}
                    className={`${prefixCls}-consulttab-formSignatureTd`}
                  >
                    <iframe
                      className={`${prefixCls}-consulttab-formSignatureTd-iframe`}
                      style={showIframe ? { display: "block" } : {}}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div className={`${prefixCls}-noData`}>
            <div className={`${prefixCls}-noData-icon`}>!</div>
            <div className={`${prefixCls}-noData-desc`}>
              <div>
                {getLabel("529126", "您当前使用的浏览器不支持【表单签章】，")}
              </div>
              <div>
                {getLabel("529127", "如需使用该功能，请使用IE浏览器！")}
              </div>
            </div>
          </div>
        )}
        <div className={`${prefixCls}-bottomBar`}>
          {this.getBootomBarItems()}
        </div>
      </div>
    );
  }
}

const Com = middleware(Autograph, "WeaAutograph");
export default Com;



// WEBPACK FOOTER //
// ./comMobx/wea-autograph/components/Autograph.js